'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
var colors = require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
var input = require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
var _switch$1 = require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
var usePrefersReducedMotion = require('../../../../hooks/use-prefers-reduced-motion.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
var fonts = require('../../../../themes/fonts.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
var screenReader = require('../../../../styles/styled-components/screen-reader.js');
var _switch = require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
require('../../../atoms/icon/font-icon/font-icon.js');
require('react-transition-group');
require('../../../atoms/alert/inline-alert/inline-alert.js');
require('../../../atoms/alert/standard-alert/standard-alert.js');
require('boring-avatars');
require('../../../atoms/tooltip/hover-tooltip/hover-tooltip.js');
require('react-laag');
var baseButton = require('../../../atoms/button/base-button/base-button.js');
require('../../../atoms/button/close-button/close-button.js');
require('../../../atoms/button/color-button/color-button.js');
require('../../../atoms/button/icon-button/icon-button.js');
require('../../../atoms/button/standard-button/standard-button.js');
require('../../../atoms/loader/circle-loader/circle-loader.js');
require('../../../atoms/loader/shimmer-loader/shimmer-loader.js');
require('../../../atoms/divider/standard-divider/standard-divider.js');
require('../../../atoms/fieldset/standard-fieldset/standard-fieldset.js');
require('../../../atoms/heading/standard-heading/standard-heading.js');
require('../../../atoms/label/standard-label/standard-label.js');
require('../../../atoms/link/button-link/button-link.js');
require('../../../atoms/link/standard-link/standard-link.js');
require('@brandfolder/utilities');
require('../../../atoms/popout/standard-popout/standard-popout.js');
require('../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js');
require('../../../atoms/table/standard-table/caption.js');
require('../../../atoms/table/standard-table/tbody.js');
require('../../../atoms/table/standard-table/tr-empty.js');
require('../../../atoms/table/standard-table/td.js');
require('../../../atoms/table/standard-table/tr.js');
require('../../../atoms/table/standard-table/table.js');
require('../../../atoms/table/standard-table/tfoot.js');
require('../../../atoms/table/standard-table/th.js');
require('../../../atoms/table/standard-table/thead.js');
require('../../../atoms/table/dnd-table/dnd-handle-td.js');
require('../../../atoms/table/dnd-table/dnd-table-drag-context.js');
var helpText = require('../../../atoms/text/help-text/help-text.js');
require('../../../atoms/text/standard-text/standard-text.js');
require('../../../internal/list/standard-list/standard-list.js');
require('../../../internal/listbox/standard-listbox/standard-listbox.js');
require('../../../internal/listitem/standard-listitem/standard-listitem.js');
require('../../../internal/option/standard-option/standard-option.js');
require('../../../internal/textarea/fake-textarea.js');
require('../../../internal/textfield/textfield-addon.js');
require('../../../internal/textfield/textfield-body.js');
require('../../../internal/textfield/textfield-header.js');
require('../../../internal/textfield/textfield-icon.js');
require('../../../internal/textfield/textfield-inner.js');
var textfieldWrapper = require('../../../internal/textfield/textfield-wrapper.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UnstyledImmediateSwitch = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { buttonProps , defaultChecked , helpText: helpText$1 , helpTextProps , id , label , labelPosition , look , onChange , readOnly , showLabel , size , switchProps , textProps , wrapperRef , ...otherProps } = props;
    const hasHelpText = !!helpText$1;
    const helpTextId = `${id}-help-text`;
    const prefersReducedMotion = usePrefersReducedMotion.usePrefersReducedMotion();
    const [checked, setChecked] = React.useState(defaultChecked);
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(()=>{
        setMounted(true);
    }, []);
    React.useEffect(()=>{
        if (mounted) {
            onChange(checked);
        }
    }, [
        checked
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ React__default.default.createElement(textfieldWrapper.TextfieldWrapper, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-switch': true,
            'bf-switch__immediate': true,
            'bf-switch__immediate--help-text': hasHelpText,
            [`bf-switch__immediate--label-${labelPosition}`]: showLabel,
            'bf-switch__immediate--label-hidden': !showLabel,
            [`bf-switch__immediate--look-${look}`]: look,
            [`bf-switch__immediate--prefers-reduced-motion`]: prefersReducedMotion,
            'bf-switch__immediate--readonly': readOnly,
            [`bf-switch__immediate--size-${size}`]: size,
            [`${otherProps?.className}`]: !!otherProps?.className
        }),
        labelPosition: labelPosition,
        ref: wrapperRef
    }), /*#__PURE__*/ React__default.default.createElement(baseButton.BaseButton, _extends({}, buttonProps, {
        "aria-checked": checked,
        "aria-describedby": hasHelpText ? helpTextId : undefined,
        "aria-readonly": readOnly || undefined,
        className: classnames__default.default({
            'bf-switch__button': true,
            [`${buttonProps?.className}`]: !!buttonProps?.className
        }),
        id: id,
        onClick: readOnly ? undefined : (e)=>{
            setChecked(!checked);
            if (buttonProps?.onClick) buttonProps.onClick(e);
        },
        ref: ref,
        role: "switch",
        type: "button"
    }), /*#__PURE__*/ React__default.default.createElement("span", _extends({}, switchProps, {
        "aria-hidden": true,
        className: classnames__default.default({
            'bf-switch__switch': true,
            [`${switchProps?.className}`]: !!switchProps?.className
        })
    })), /*#__PURE__*/ React__default.default.createElement("span", _extends({}, textProps, {
        className: classnames__default.default({
            'bf-switch__text': true,
            [`${textProps?.className}`]: !!textProps?.className
        })
    }), label)), hasHelpText && /*#__PURE__*/ React__default.default.createElement(helpText.HelpText, _extends({}, helpTextProps, {
        id: helpTextId
    }), helpText$1));
});
const Switch = styled__default.default(UnstyledImmediateSwitch)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  position: relative;

  .bf-switch__switch {
    ${()=>_switch.getSwitchBase()}
    ${({ look  })=>_switch.getSwitchUnchecked({
        look
    })}
  }

  .bf-switch__button {
    align-items: center;
    appearance: none;
    background-color: transparent;
    border: 0;
    color: ${colors.BrandfolderHexColors.Text};
    cursor: pointer;
    display: flex;
    font-family: ${fonts.fontFamilyBook};
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    margin: 0;
    padding: 0;
    text-align: left;

    &:focus {
      outline: 0;
    }

    &:focus-visible {
      .bf-switch__switch {
        ${({ look  })=>_switch.getSwitchOutline({
        look
    })}
      }
    }

    &[aria-checked='true'] {
      .bf-switch__switch {
        ${({ look  })=>_switch.getSwitchChecked({
        look
    })}
      }
    }

    &[aria-readonly='true'] {
      .bf-switch__switch {
        ${({ look  })=>_switch.getSwitchDisabled({
        look
    })}
      }
    }
  }

  &.bf-switch__immediate--label-hidden {
    .bf-switch__text {
      ${screenReader.screenReaderOnly}
    }

    .bf-text__help {
      ${screenReader.screenReaderOnly}
      margin-left: 0;
    }
  }

  &.bf-switch__immediate--size-small {
    .bf-switch__button {
      .bf-switch__switch {
        ${_switch.switchSmall}
      }

      &[aria-checked='false'] {
        .bf-switch__switch {
          &:after {
            ${_switch.switchSmallOff}
          }
        }
      }
    }

    &.bf-textfield__wrapper--label-position-left {
      ${_switch.switchSmallLabelLeft}
    }

    &.bf-textfield__wrapper--label-position-right {
      ${_switch.switchSmallLabelRight}
    }
  }

  &.bf-switch__immediate--size-medium {
    .bf-switch__button {
      .bf-switch__switch {
        ${_switch.switchMedium}
      }

      &[aria-checked='false'] {
        .bf-switch__switch {
          &:after {
            ${_switch.switchMediumOff}
          }
        }
      }
    }

    &.bf-textfield__wrapper--label-position-left {
      ${_switch.switchMediumLabelLeft}
    }

    &.bf-textfield__wrapper--label-position-right {
      ${_switch.switchMediumLabelRight}
    }
  }

  &.bf-textfield__wrapper--label-position-left {
    align-items: flex-end;

    .bf-switch__switch {
      order: 1;
    }
  }

  &.bf-switch__immediate--prefers-reduced-motion {
    .bf-switch__switch {
      ${_switch.switchReducedMotion}
    }
  }
`;
/**
 * A `ImmediateSwitch` represents on/off values using `<button aria-checked="true" role="switch" type="button" />`.
 *
 * This component differs from `CheckboxSwitch` in that `ImmediateSwitch` is meant to be used without a form,
 * where the changed on/off value immediately fires an API call (without any type of form submission).
 * An example implementation using this component with `react-hot-toast` is in the companion Examples story.
 *
 * Required attributes for `ImmediateSwitch` are `id`, `label`, on `onChange`.
 * Common optional attributes include `defaultChecked`, `helpText`, and `readOnly`.
 * You may hide the label visually (but still be accessible to screen readers) by passing `showLabel={false}`,
 * though this is not recommended.
 *
 * `ImmediateSwitch` sizing defaults to `SwitchSize.Small` (16px circle),
 * with a `SwitchSize.Medium` available (24px circle).
 *
 * Labels may be placed on the right hand side via `InputLabelPositions.Right` (default)
 * or on the left via `InputLabelPositions.Left`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/switch_role
 *
 * https://www.w3.org/WAI/ARIA/apg/patterns/switch/examples/switch-button/
 */ const ImmediateSwitch = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { defaultChecked =false , labelPosition =input.InputLabelPositions.Right , look =input.InputLooks.Default , readOnly =false , showLabel =true , size =_switch$1.SwitchSize.Small , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Switch, _extends({}, otherProps, {
        defaultChecked: defaultChecked,
        labelPosition: labelPosition,
        look: look,
        readOnly: readOnly,
        ref: ref,
        showLabel: showLabel,
        size: size
    })));
});

exports.ImmediateSwitch = ImmediateSwitch;
exports.UnstyledImmediateSwitch = UnstyledImmediateSwitch;
//# sourceMappingURL=immediate-switch.js.map
